import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACCOMPANYING_VISITOR_LISTING_PATH,
  ACCOMPANYING_VISITOR_PATH,
  ACTION_BACK_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const AccompanyingVisitorListingPage = lazy(
  () => import('@features/ConsentAndPermission/AccompanyingVisitor/pages/AccompanyingVisitorListing')
);
const AccompanyingVisitorPage = lazy(
  () => import('@features/ConsentAndPermission/AccompanyingVisitor/pages/AccompanyingVisitor')
);

export const ACCOMPANYING_VISITOR_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AccompanyingVisitorListingPage />,
    displayTitle: () => 'Accompanying Visitor',
    pageType: PageType.PRIVATE,
    path: ACCOMPANYING_VISITOR_LISTING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.visitorRegistration,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AccompanyingVisitorPage />,
    displayTitle: () => 'Accompanying Visitor',
    pageType: PageType.PRIVATE,
    path: ACCOMPANYING_VISITOR_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.visitorRegistration,
  },
];
